"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactNativeWeb = require("react-native-web");

var _crossPlatformComponents = require("@airasia/cross-platform-components");

var _uiUtils = require("@airasia/ui-utils");

var _AaPicker = _interopRequireDefault(require("../airasia_picker-container/AaPicker.component"));

var _AaPassengerRoomSelection = require("./AaPassengerRoomSelection.model");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var AaPassengerSelectionStepper = function AaPassengerSelectionStepper(props) {
  var _useState = (0, _react.useState)(props),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      selectionStepperProps = _useState2[0],
      setSelectionStepperProps = _useState2[1];

  var _useState3 = (0, _react.useState)(props.childAgeData || []),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      childAges = _useState4[0],
      setChildAge = _useState4[1];

  var defaultValueAge = 1;
  var _props$ageList = props.ageList,
      ageList = _props$ageList === void 0 ? [] : _props$ageList,
      childAgeLabel = props.childAgeLabel;
  (0, _react.useEffect)(function () {
    setSelectionStepperProps(props);

    if (props.controls.type === 'child' && props.data > 0 && childAges && props.childAgeData && childAges.length != props.childAgeData.length) {
      setChildAge(props.childAgeData);
    }

    if (props.data === 0) setChildAge([]); // We push on change for select picker
  }, [props.childAgeData, props.data, props.controls.type]);

  var onIncrementPax = function onIncrementPax() {
    props.controls.stepperClicked(selectionStepperProps.controls.type, _AaPassengerRoomSelection.STEPPER_EVENTS.INCREMENT);
  };

  var onDecrementPax = function onDecrementPax() {
    props.controls.stepperClicked(selectionStepperProps.controls.type, _AaPassengerRoomSelection.STEPPER_EVENTS.DECREMENT);
  };

  var stepperControls = {
    onIncrement: onIncrementPax,
    onDecrement: onDecrementPax,
    showNumber: true,
    min: selectionStepperProps.controls.min
  };

  var onSelectChild = function onSelectChild(item, room) {
    childAges[room] = item;

    if (props.controls.onChangeChildAge) {
      props.controls.onChangeChildAge(childAges);
    }
  };

  var combinedStepperControls = _objectSpread({}, stepperControls);

  var propsAccessibility = {
    addAccessibilityProps: null,
    removeAccessibilityProps: null
  };

  if (selectionStepperProps.controls.accessibilityProps) {
    if (selectionStepperProps.controls.accessibilityProps.addButtonProps) {
      propsAccessibility.addAccessibilityProps = selectionStepperProps.controls.accessibilityProps.addButtonProps;
    }

    if (selectionStepperProps.controls.accessibilityProps.removeButtonProps) {
      propsAccessibility.removeAccessibilityProps = selectionStepperProps.controls.accessibilityProps.removeButtonProps;
    }

    combinedStepperControls = _objectSpread(_objectSpread({}, stepperControls), {}, {
      accessibilityProps: propsAccessibility
    });
  }

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: styles.container
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, null, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
    style: styles.label
  }, selectionStepperProps.controls.description[selectionStepperProps.controls.type].label), selectionStepperProps.controls.description[selectionStepperProps.controls.type].sublabel ? /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
    style: styles.subLabel
  }, selectionStepperProps.controls.description[selectionStepperProps.controls.type].sublabel) : null), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, null, /*#__PURE__*/_react["default"].createElement(_crossPlatformComponents.AaStepper, {
    controls: _objectSpread(_objectSpread({}, combinedStepperControls), {}, {
      max: selectionStepperProps.controls.max
    }),
    data: selectionStepperProps.data
  }))), selectionStepperProps.controls.type === 'child' && /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      flexGrow: 2
    }
  }, childAges.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: {
        minWidth: '48%',
        paddingVertical: 6,
        paddingLeft: index % 2 === 0 ? 0 : 18
      }
    }, /*#__PURE__*/_react["default"].createElement(_AaPicker["default"], {
      data: ageList,
      label: "".concat(childAgeLabel.replace('{0}', index + 1)),
      defaultItem: item,
      onSelectItemHandle: function onSelectItemHandle(selectItem) {
        onSelectChild(selectItem, index);
      }
    }));
  })));
};

var styles = _crossPlatformComponents.StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 15
  },
  label: {
    fontSize: 16,
    color: '#212124',
    fontFamily: _uiUtils.DefaultTokens.FONT_MEDIUM,
    web: {
      fontWeight: '500',
      fontFamily: _uiUtils.DefaultTokens.FONT_WEB
    }
  },
  subLabel: {
    fontSize: 12,
    color: '#75767a',
    fontFamily: _uiUtils.DefaultTokens.FONT_REGULAR,
    web: {
      fontWeight: '400',
      fontFamily: _uiUtils.DefaultTokens.FONT_WEB
    }
  }
});

var _default = AaPassengerSelectionStepper;
exports["default"] = _default;